import { hasValue } from '@util';
import * as R from 'ramda';

export interface ProgressStatus {
  id: string;
  description: string;
}

const ACCEPTED_STATUS_ID = 'A';
const ACCEPTED_STATUS_DESCRIPTION = 'progressstatus.A';
export const ACCEPTED_STATUS = {id: ACCEPTED_STATUS_ID, description: ACCEPTED_STATUS_DESCRIPTION};

export const hasSelectedAccepted = (progressStatuses: ProgressStatus[]) => {
  const filter = (progressStatus: ProgressStatus) => progressStatus?.id === ACCEPTED_STATUS_ID;

  return hasValue(progressStatuses) && hasValue(R.filter(filter, progressStatuses));
};
